<template>
    <v-dialog v-model="genericDialog" scrollable max-width="350" :fullscreen="!isDesktop">
        <v-card>
            <v-btn icon absolute top right @click="genericDialog = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-card-title class="text-center justify-center">
                {{title}}
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 300px;" class="pa-0">
                <slot></slot>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: {
        title: String,
        message: String,
        value: Boolean
    },

    computed: {
        genericDialog: {
            get() {
                return this.value
            },
            set(value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>